import { createSelector } from "reselect";
import getIsUIWebView from "selectors/device/getIsUIWebView";
import getIsChrome from "selectors/device/getIsChrome";

const getIsiOSChrome = createSelector(
  [getIsChrome, getIsUIWebView],
  (isChrome, isUIWebView) => isChrome && isUIWebView,
);

export default getIsiOSChrome;
